import React, { createContext, useContext, useState } from "react";
import axiosInstance, { handleApiError } from "../services/axiosService";
import { useTreeContext } from "./TreeDataContext";
import { createChecksum } from "../commonFunctions/fileFolderConfig";
import { useAppOrgContext } from "./AppOrgContext";
import { getTreeDataForCron } from "../utils/treeData/treeDataUtils";
// import { useAppOrgContext } from './AppOrgContext';

const CronContextApi = createContext();
const useCronContext = () => useContext(CronContextApi);

const CronContext = ({ children }) => {
  const [selectedCron, setSelectedCron] = useState({ id: "", name: "" });
  const { currentChecksum } = useAppOrgContext();

  const [cronData, setCronData] = useState({
    name: "",
    expression: "",
    function: ""
  });

  const { setCronExplorerData } = useTreeContext();

  const fetchAllCron = async () => {
    const { data } = await axiosInstance.get(`/cronconfig`);
    const treeData = getTreeDataForCron(data);
    setCronExplorerData(treeData);
  };

  const getCronConfig = () => {
    return cronData;
  };

  const handleSaveCron = async () => {
    try {
      const config = getCronConfig();
      const { message } = await axiosInstance.put(`/cronconfig/${selectedCron.id}`, config);

      const newChecksum = createChecksum(config);
      currentChecksum.current = newChecksum;
      return {
        data: config,
        message
      };
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  };

  return (
    <CronContextApi.Provider
      value={{
        selectedCron,
        cronData,
        fetchAllCron,
        handleSaveCron,
        setSelectedCron,
        setCronData,
        getCronConfig
      }}
    >
      {children}
    </CronContextApi.Provider>
  );
};

export default CronContext;
export { useCronContext };
